import { Pipe, PipeTransform } from '@angular/core';
import { TimeFormat } from '@agilox/ui-common';

@Pipe({
	name: 'timePickerMinute',
})
export class TimePickerMinutePipe implements PipeTransform {
	transform(value: string | undefined): any {
		if (!value) {
			return '00';
		}
		value = value.split(':')[1];
		if (!value) {
			return '00';
		}

		if (value.includes(' ')) {
			value = value.split(' ')[0];
		}

		return value.padStart(2, '0');
	}
}
